var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_958_85281)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_958_85281",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_958_85281)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_958_85281",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_958_85281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2957 4.40853C12.3557 4.40853 7.65765 1.66357 7.65765 1.66357C6.48348 2.80941 7.89202 5.7806 7.89202 5.7806C5.77869 6.00977 5.30902 8.98372 5.30902 8.98372C3.89985 6.69622 0.630293 7.06689 0.846126 7.15023C5.78029 9.20939 3.19476 16.7588 3.19476 16.7588C3.81249 16.6117 4.37891 16.2994 4.83376 15.8563C5.2886 15.4132 5.61458 14.8554 5.77777 14.2417C6.24777 15.6167 9.30153 16.3006 9.30153 16.3006C8.83594 16.8497 8.27901 17.3151 7.65602 17.6759H11.1798C11.9851 17.661 12.7643 17.3855 13.3998 16.8906C14.0354 16.3957 14.4934 15.7081 14.7052 14.931L12.3549 14.4728L13.0613 12.1852H12.3549L12.5909 10.5837H11.8862V7.61003L13.7644 9.89762L13.5284 11.2729L14.7035 10.3558V12.1893L16.5818 11.7311L16.8178 14.0187C17.4616 13.6843 18.0128 13.1956 18.4226 12.597C18.8324 11.9984 19.0876 11.3081 19.1664 10.5869C19.1689 5.32525 14.2357 4.40853 13.2957 4.40853ZM15.2211 7.90869C15.0563 7.90869 14.8943 7.85947 14.7573 7.7679C14.6202 7.67634 14.5143 7.54664 14.4513 7.39437C14.3882 7.2421 14.3703 7.07425 14.4024 6.9126C14.4346 6.75095 14.5154 6.60271 14.6319 6.48617C14.7485 6.36962 14.8967 6.28964 15.0584 6.25749C15.22 6.22533 15.3879 6.24243 15.5401 6.3055C15.6924 6.36857 15.8213 6.47526 15.9129 6.6123C16.0044 6.74935 16.0545 6.91054 16.0545 7.07536C16.0545 7.29637 15.9666 7.50827 15.8103 7.66455C15.654 7.82083 15.4421 7.90869 15.2211 7.90869Z"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_958_85281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFish);
export default __webpack_public_path__ + "static/media/icon-fish.d2bf9ca569ad606a93e1c4fa2e203796.svg";
export { ForwardRef as ReactComponent };